import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './Tooltip.module.scss';

const Tooltip = ({ children, text, position = 'below' }) => {
  const [visible, setVisible] = useState(false);
  const tooltipClass = `${styles.tooltipText} ${styles[position]}`;
  return (
    <div
      className={text ? styles.tooltipContainer : ''}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {text && visible && <div className={tooltipClass}>{text}</div>}
    </div>
  );
};

export default Tooltip;
Tooltip.propTypes = {
  children: PropTypes.node,
  text: PropTypes.string,
  position: PropTypes.string,
};
